import { Injectable } from '@angular/core';
import moment from 'moment-timezone';
import { LocationService } from './location.service';
import { LogSeverity, LoggingService } from '@core/services/logging.service';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  constructor(private locationService: LocationService, private logger: LoggingService) {
    this.setDefaultTimezone();
  }

  async setDefaultTimezone() {
    const storeId = localStorage.getItem('storeId');

    if (!storeId) {
      this.logger.writeLog('[LocaleService] Store ID is missing, unable to set the timezone', {
        severity: LogSeverity.WARNING,
        storeId,
      });
      return;
    }

    try {
      const { timezoneId } = await this.locationService.getStoreInformation();
      moment.tz.setDefault(timezoneId ?? moment.tz.guess());
      this.logger.writeLog(`[LocaleService] Setting the timezone ${timezoneId} for store ID ${storeId}`, {
        severity: LogSeverity.INFO,
        storeId,
      });
    } catch (error) {
      const message = error instanceof Error ? error.message : error;
      this.logger.writeLog(
        `[LocaleService] It wasn't possible to set the timezone for store ID ${storeId}: ${message}`,
        {
          severity: LogSeverity.ERROR,
          storeId,
        },
      );
    }
  }
}
